'use client'

import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

export interface SelectionItem {
  id: string | number
  name: ReactNode
  kind?: string
  preview?: string
}

interface SelectionsDrawerProps {
  open?: boolean
  onToggle?: () => void
  count?: number
  title?: ReactNode
  hint?: ReactNode
  items?: SelectionItem[]
  onRemove?: (id: SelectionItem['id']) => void
  empty?: ReactNode
  children?: ReactNode
  className?: string
}

export function SelectionsDrawer({
  open,
  onToggle,
  count = 0,
  title,
  hint,
  items = [],
  onRemove,
  empty,
  children,
  className
}: SelectionsDrawerProps) {
  return (
    <div className={cx('st-selections', open && 'open', className)}>
      <div className="st-sel-header" onClick={onToggle}>
        <span className="pill">{count} PICKED</span>
        <b>{title}</b>
        {hint && <span className="hint">{hint}</span>}
        <span className="toggle-caret" aria-hidden />
      </div>
      <div className="st-sel-body">
        {children ? (
          children
        ) : items.length === 0 ? (
          <div className="st-sel-empty">{empty || 'No selections yet — flag items to see them here'}</div>
        ) : (
          <div className="st-sel-grid">
            {items.map((it) => (
              <div key={it.id} className="st-sel-card">
                <div className="sc-preview" style={it.preview ? { backgroundImage: `url(${it.preview})` } : undefined}>
                  {!it.preview && (it.kind || 'FILE')}
                </div>
                <div className="sc-name">{it.name}</div>
                <button
                  type="button"
                  className="sc-x"
                  aria-label="Remove"
                  onClick={(e) => {
                    e.stopPropagation()
                    onRemove?.(it.id)
                  }}>
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
